import { PropertyMapper } from '../../decorators';

export class ProjectStatus {
    @PropertyMapper()
    public id: number;

    @PropertyMapper()
    public name: string;
}
